export const SITE_ORIGIN = 'https://solaceintegrations.com';

export function canonicalUrl(pathname = '/') {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  if (normalizedPath === '/') {
    return `${SITE_ORIGIN}/`;
  }
  return `${SITE_ORIGIN}${normalizedPath.replace(/\/$/, '')}`;
}
